import React from "react";
import {toAbsoluteUrl} from "../../../_metronic/_helpers";

export function ProposalApproveSuccessPage() {
  return (
    <div className="d-flex flex-column flex-root">
      <div
        className="d-flex flex-row-fluid flex-column bgi-size-cover bgi-position-center bgi-no-repeat p-10 p-sm-30"
        style={{
        }}
      >
        <h1
          className="font-size-sm-100 font-weight-boldest text-dark-75 mt-15"
          style={{ fontSize: "150px" }}
        >
          Approved
        </h1>
        <p className="font-size-h2 font-weight-light">
          Successfully approved Proposal
        </p>
        <p className="font-size-h4 font-weight-light">
          You may now close this browser
        </p>
      </div>
    </div>
  );
}
